import { ErrorMessage, Field } from 'formik';

import ReactSelect from './ReactSelect';
import TextError from './TextError';

import '../../captains-form/styles/mandatory-check.scss';
import '../styles/multi-select.scss';

export default function MultiSelect(props) {
  const {
    label,
    name,
    onInputChange,
    onChange,
    hasError = false,
    errorMessage = '',
    required = false,
    ...rest
  } = props;

  const handleOnInputChange = (e) => {
    if (onInputChange) {
      onInputChange(e);
    }
  };

  return (
    <div className={'form-control multi-select'}>
      {label ? (
        <label className="input__label" htmlFor={name}>
          {label}
          {required ? <span>*</span> : null}
        </label>
      ) : null}
      {props.sublabel ? (
        <span className="sublabel">{props.sublabel}</span>
      ) : null}
      <Field
        name={name}
        id={name}
        onChange={onChange}
        isMulti={true}
        component={ReactSelect}
        onInputChange={(e) => handleOnInputChange(e)}
        className={hasError ? 'input-error-border' : ''}
        {...rest}
      />
      {hasError ? <div className="error-dropdown">{errorMessage}</div> : null}
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
}
